/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FilloutRouteImport } from './routes/fillout'
import { Route as LoggedOutRouteImport } from './routes/logged-out'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as FilloutIndexRouteImport } from './routes/fillout/index'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as PortalSelf_registrationRouteImport } from './routes/portal/self_registration'
import { Route as PortalOutcomesIndexRouteImport } from './routes/portal/outcomes.index'
import { Route as PortalReportsReportIdRouteImport } from './routes/portal/reports.$reportId'
import { Route as RegistrationSlugLoginRouteImport } from './routes/registration/$slug/login'
import { Route as RegistrationSlugRegisterRouteImport } from './routes/registration/$slug/register'
import { Route as RegistrationSlugRegisteredRouteImport } from './routes/registration/$slug/registered'
import { Route as PortalOutcomesResponseIdAnswersRouteImport } from './routes/portal/outcomes.$responseId.answers'
import { Route as PortalProtocol_subscriptionsProtocolSubscriptionIdStopRouteImport } from './routes/portal/protocol_subscriptions.$protocolSubscriptionId.stop'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FilloutRoute = FilloutRouteImport.update({
  id: '/fillout',
  path: '/fillout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggedOutRoute = LoggedOutRouteImport.update({
  id: '/logged-out',
  path: '/logged-out',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const FilloutIndexRoute = FilloutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FilloutRoute,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSelf_registrationRoute = PortalSelf_registrationRouteImport.update({
  id: '/self_registration',
  path: '/self_registration',
  getParentRoute: () => PortalRoute,
} as any)
const PortalOutcomesIndexRoute = PortalOutcomesIndexRouteImport.update({
  id: '/outcomes/',
  path: '/outcomes/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalReportsReportIdRoute = PortalReportsReportIdRouteImport.update({
  id: '/reports/$reportId',
  path: '/reports/$reportId',
  getParentRoute: () => PortalRoute,
} as any)
const RegistrationSlugLoginRoute = RegistrationSlugLoginRouteImport.update({
  id: '/registration/$slug/login',
  path: '/registration/$slug/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistrationSlugRegisterRoute =
  RegistrationSlugRegisterRouteImport.update({
    id: '/registration/$slug/register',
    path: '/registration/$slug/register',
    getParentRoute: () => rootRouteImport,
  } as any)
const RegistrationSlugRegisteredRoute =
  RegistrationSlugRegisteredRouteImport.update({
    id: '/registration/$slug/registered',
    path: '/registration/$slug/registered',
    getParentRoute: () => rootRouteImport,
  } as any)
const PortalOutcomesResponseIdAnswersRoute =
  PortalOutcomesResponseIdAnswersRouteImport.update({
    id: '/outcomes/$responseId/answers',
    path: '/outcomes/$responseId/answers',
    getParentRoute: () => PortalRoute,
  } as any)
const PortalProtocol_subscriptionsProtocolSubscriptionIdStopRoute =
  PortalProtocol_subscriptionsProtocolSubscriptionIdStopRouteImport.update({
    id: '/protocol_subscriptions/$protocolSubscriptionId/stop',
    path: '/protocol_subscriptions/$protocolSubscriptionId/stop',
    getParentRoute: () => PortalRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/fillout': typeof FilloutRouteWithChildren
  '/logged-out': typeof LoggedOutRoute
  '/portal': typeof PortalRouteWithChildren
  '/portal/self_registration': typeof PortalSelf_registrationRoute
  '/fillout/': typeof FilloutIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/portal/reports/$reportId': typeof PortalReportsReportIdRoute
  '/registration/$slug/login': typeof RegistrationSlugLoginRoute
  '/registration/$slug/register': typeof RegistrationSlugRegisterRoute
  '/registration/$slug/registered': typeof RegistrationSlugRegisteredRoute
  '/portal/outcomes/': typeof PortalOutcomesIndexRoute
  '/portal/outcomes/$responseId/answers': typeof PortalOutcomesResponseIdAnswersRoute
  '/portal/protocol_subscriptions/$protocolSubscriptionId/stop': typeof PortalProtocol_subscriptionsProtocolSubscriptionIdStopRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/logged-out': typeof LoggedOutRoute
  '/portal/self_registration': typeof PortalSelf_registrationRoute
  '/fillout': typeof FilloutIndexRoute
  '/portal': typeof PortalIndexRoute
  '/portal/reports/$reportId': typeof PortalReportsReportIdRoute
  '/registration/$slug/login': typeof RegistrationSlugLoginRoute
  '/registration/$slug/register': typeof RegistrationSlugRegisterRoute
  '/registration/$slug/registered': typeof RegistrationSlugRegisteredRoute
  '/portal/outcomes': typeof PortalOutcomesIndexRoute
  '/portal/outcomes/$responseId/answers': typeof PortalOutcomesResponseIdAnswersRoute
  '/portal/protocol_subscriptions/$protocolSubscriptionId/stop': typeof PortalProtocol_subscriptionsProtocolSubscriptionIdStopRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/fillout': typeof FilloutRouteWithChildren
  '/logged-out': typeof LoggedOutRoute
  '/portal': typeof PortalRouteWithChildren
  '/portal/self_registration': typeof PortalSelf_registrationRoute
  '/fillout/': typeof FilloutIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/portal/reports/$reportId': typeof PortalReportsReportIdRoute
  '/registration/$slug/login': typeof RegistrationSlugLoginRoute
  '/registration/$slug/register': typeof RegistrationSlugRegisterRoute
  '/registration/$slug/registered': typeof RegistrationSlugRegisteredRoute
  '/portal/outcomes/': typeof PortalOutcomesIndexRoute
  '/portal/outcomes/$responseId/answers': typeof PortalOutcomesResponseIdAnswersRoute
  '/portal/protocol_subscriptions/$protocolSubscriptionId/stop': typeof PortalProtocol_subscriptionsProtocolSubscriptionIdStopRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/fillout'
    | '/logged-out'
    | '/portal'
    | '/portal/self_registration'
    | '/fillout/'
    | '/portal/'
    | '/portal/reports/$reportId'
    | '/registration/$slug/login'
    | '/registration/$slug/register'
    | '/registration/$slug/registered'
    | '/portal/outcomes/'
    | '/portal/outcomes/$responseId/answers'
    | '/portal/protocol_subscriptions/$protocolSubscriptionId/stop'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/logged-out'
    | '/portal/self_registration'
    | '/fillout'
    | '/portal'
    | '/portal/reports/$reportId'
    | '/registration/$slug/login'
    | '/registration/$slug/register'
    | '/registration/$slug/registered'
    | '/portal/outcomes'
    | '/portal/outcomes/$responseId/answers'
    | '/portal/protocol_subscriptions/$protocolSubscriptionId/stop'
  id:
    | '__root__'
    | '/'
    | '/fillout'
    | '/logged-out'
    | '/portal'
    | '/portal/self_registration'
    | '/fillout/'
    | '/portal/'
    | '/portal/reports/$reportId'
    | '/registration/$slug/login'
    | '/registration/$slug/register'
    | '/registration/$slug/registered'
    | '/portal/outcomes/'
    | '/portal/outcomes/$responseId/answers'
    | '/portal/protocol_subscriptions/$protocolSubscriptionId/stop'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  FilloutRoute: typeof FilloutRouteWithChildren
  LoggedOutRoute: typeof LoggedOutRoute
  PortalRoute: typeof PortalRouteWithChildren
  RegistrationSlugLoginRoute: typeof RegistrationSlugLoginRoute
  RegistrationSlugRegisterRoute: typeof RegistrationSlugRegisterRoute
  RegistrationSlugRegisteredRoute: typeof RegistrationSlugRegisteredRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fillout': {
      id: '/fillout'
      path: '/fillout'
      fullPath: '/fillout'
      preLoaderRoute: typeof FilloutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logged-out': {
      id: '/logged-out'
      path: '/logged-out'
      fullPath: '/logged-out'
      preLoaderRoute: typeof LoggedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fillout/': {
      id: '/fillout/'
      path: '/'
      fullPath: '/fillout/'
      preLoaderRoute: typeof FilloutIndexRouteImport
      parentRoute: typeof FilloutRoute
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/self_registration': {
      id: '/portal/self_registration'
      path: '/self_registration'
      fullPath: '/portal/self_registration'
      preLoaderRoute: typeof PortalSelf_registrationRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/outcomes/': {
      id: '/portal/outcomes/'
      path: '/outcomes'
      fullPath: '/portal/outcomes/'
      preLoaderRoute: typeof PortalOutcomesIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/reports/$reportId': {
      id: '/portal/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/portal/reports/$reportId'
      preLoaderRoute: typeof PortalReportsReportIdRouteImport
      parentRoute: typeof PortalRoute
    }
    '/registration/$slug/login': {
      id: '/registration/$slug/login'
      path: '/registration/$slug/login'
      fullPath: '/registration/$slug/login'
      preLoaderRoute: typeof RegistrationSlugLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registration/$slug/register': {
      id: '/registration/$slug/register'
      path: '/registration/$slug/register'
      fullPath: '/registration/$slug/register'
      preLoaderRoute: typeof RegistrationSlugRegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registration/$slug/registered': {
      id: '/registration/$slug/registered'
      path: '/registration/$slug/registered'
      fullPath: '/registration/$slug/registered'
      preLoaderRoute: typeof RegistrationSlugRegisteredRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/outcomes/$responseId/answers': {
      id: '/portal/outcomes/$responseId/answers'
      path: '/outcomes/$responseId/answers'
      fullPath: '/portal/outcomes/$responseId/answers'
      preLoaderRoute: typeof PortalOutcomesResponseIdAnswersRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/protocol_subscriptions/$protocolSubscriptionId/stop': {
      id: '/portal/protocol_subscriptions/$protocolSubscriptionId/stop'
      path: '/protocol_subscriptions/$protocolSubscriptionId/stop'
      fullPath: '/portal/protocol_subscriptions/$protocolSubscriptionId/stop'
      preLoaderRoute: typeof PortalProtocol_subscriptionsProtocolSubscriptionIdStopRouteImport
      parentRoute: typeof PortalRoute
    }
  }
}

interface FilloutRouteChildren {
  FilloutIndexRoute: typeof FilloutIndexRoute
}

const FilloutRouteChildren: FilloutRouteChildren = {
  FilloutIndexRoute: FilloutIndexRoute,
}

const FilloutRouteWithChildren =
  FilloutRoute._addFileChildren(FilloutRouteChildren)

interface PortalRouteChildren {
  PortalSelf_registrationRoute: typeof PortalSelf_registrationRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PortalReportsReportIdRoute: typeof PortalReportsReportIdRoute
  PortalOutcomesIndexRoute: typeof PortalOutcomesIndexRoute
  PortalOutcomesResponseIdAnswersRoute: typeof PortalOutcomesResponseIdAnswersRoute
  PortalProtocol_subscriptionsProtocolSubscriptionIdStopRoute: typeof PortalProtocol_subscriptionsProtocolSubscriptionIdStopRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalSelf_registrationRoute: PortalSelf_registrationRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalReportsReportIdRoute: PortalReportsReportIdRoute,
  PortalOutcomesIndexRoute: PortalOutcomesIndexRoute,
  PortalOutcomesResponseIdAnswersRoute: PortalOutcomesResponseIdAnswersRoute,
  PortalProtocol_subscriptionsProtocolSubscriptionIdStopRoute:
    PortalProtocol_subscriptionsProtocolSubscriptionIdStopRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  FilloutRoute: FilloutRouteWithChildren,
  LoggedOutRoute: LoggedOutRoute,
  PortalRoute: PortalRouteWithChildren,
  RegistrationSlugLoginRoute: RegistrationSlugLoginRoute,
  RegistrationSlugRegisterRoute: RegistrationSlugRegisterRoute,
  RegistrationSlugRegisteredRoute: RegistrationSlugRegisteredRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
